// extracted by mini-css-extract-plugin
export default {"pageWrap":"Id-z","fullWidth":"Jd-z","heading":"Kd-z","fullBleed":"Ld-z","hidden":"Md-z"};